import React, { useEffect, useRef, useState } from "react";
import { Collapse } from "antd";
import { DeleteFilled } from "@ant-design/icons";
import QuestionsChildren from "./QuestionsChildren";
import { useFormContext } from "react-hook-form";
import { useDrag, useDrop } from "react-dnd";

const PagesList = ({
    pages,
    onDeletePage,
    move,
    collapsedPage,
    setCollapsedPage,
}) => {
    const changeCollapsedPageKeyHandler = (keysArr) => {
        const key = keysArr[0];
        if (key === collapsedPage) {
            setCollapsedPage(null);
        } else {
            setCollapsedPage(key);
        }
    };

    const {
        formState: { errors },
    } = useFormContext();
    const setBorderRadius = (pageIndex) => {
        if (pageIndex === 0 && pageIndex === pages.length - 1) return "8px";
        if (pageIndex === 0 && pageIndex !== pages.length - 1)
            return "8px 8px 0 0";
        if (pageIndex === pages.length - 1) return "0 0 8px 8px";
        return "0";
    };

    const collapseProps = () => {
        return pages.map((page, index) => ({
            key: page.id,
            label: <CollapseHeader movePage={move} pageIndex={index} />,
            children: <QuestionsChildren pageIndex={index} />,
            extra: (
                <>
                    {pages.length > 1 && (
                        <DeletePageIcon
                            onDelete={onDeletePage.bind(null, page.id)}
                        />
                    )}
                </>
            ),
            ...{
                ...(errors?.pages?.[index] && {
                    style: {
                        border: "1px solid #ff0000",
                        borderRadius: setBorderRadius(index),
                    },
                }),
            },
        }));
    };

    return (
        <Collapse
            style={{ width: "100%" }}
            activeKey={collapsedPage}
            onChange={changeCollapsedPageKeyHandler}
            accordion
            items={collapseProps()}
        />
    );
};

function DeletePageIcon({ onDelete }) {
    const deletePageHandler = (e) => {
        e.stopPropagation();
        onDelete();
    };

    return (
        <div onClick={deletePageHandler}>
            <DeleteFilled />
        </div>
    );
}

function CollapseHeader({ pageIndex, movePage, id }) {
    const ref = useRef(null);

    const [{ handlerId }, drop] = useDrop({
        accept: "item",
        collect(monitor) {
            return {
                handlerId: monitor.getHandlerId(),
            };
        },
        hover(item, monitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = pageIndex;

            if (dragIndex === hoverIndex) {
                return;
            }

            const hoverBoundingRect = ref.current?.getBoundingClientRect();
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            const clientOffset = monitor.getClientOffset();
            const hoverClientY = clientOffset.y - hoverBoundingRect.top;

            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            movePage(dragIndex, hoverIndex);

            item.index = hoverIndex;
        },
    });

    const [{ isDragging }, drag] = useDrag({
        type: "item",
        item: () => {
            return { id, index: pageIndex };
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
    drag(drop(ref));

    return (
        <div ref={ref} style={{ width: "100%", opacity: isDragging ? 0.2 : 1 }}>
            <p>Page #{pageIndex + 1}</p>
        </div>
    );
}

export default PagesList;
